// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#8b33e2","secondaryColor":"#B298DC","textDark":"#000000","titleFont":"\"VT323\", monospace","baseFont":"\"Ubuntu\", sans-serif"};